import { useI18n } from "vue-i18n";

// Hub errors are { code, message }; a known code gets a translated message, anything else shows the server's text.
export function useErrorText() {
  const { t, te } = useI18n();
  return (e) => {
    if (!e) return "";
    if (typeof e === "string") return e;
    if (e.code && te(`errors.codes.${e.code}`)) return t(`errors.codes.${e.code}`);
    if (e.status === 0) return t("errors.network");
    return e.message || t("errors.generic");
  };
}

export function formatDate(value, withTime = true) {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return withTime ? d.toLocaleString() : d.toLocaleDateString();
}
